import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/products")({
	beforeLoad: ({ location }) => {
		const owner = (location.search as Record<string, unknown>).owner_party_id;
		throw redirect({
			to: "/catalog/products",
			search: { owner_party_id: typeof owner === "string" ? owner : undefined },
		});
	},
});
